import React, {useState, useEffect} from "react";
import {KoerberEmbed} from "./Embed.style";
import EmbedHtml from "./EmbedHtml";
import {ErrorBoundary} from "react-error-boundary";
import {urlHasParam} from "../../utils/js/params";
import EmbedHtmlMarketo from "./EmbedHtmlMarketo";
import clearNativeMarketoStylesheet from "../StickyForm/StickyForm"
import {EmbeddedFormWrapper} from "../StickyForm/StickyForm.style";
import { generateHTML } from "../../utils/js/clear-native-marketo-stylesheet";

function Embed(props) {
    const {
        embedType,
        embedHtml,
        embedUrl,
        youtubeVideoId,
        youtubeAccessibilityLabel,
        youtubeMute,
        youtubeAutoPlay,
        youtubeLoop,
        youtubePlaysInline,
        youtubeRel,
        embedId,
        styleMarketo,
        captchaConfig,
        pageLanguage
    } = props;

    const clearNativeMarketoStylesheet = generateHTML(captchaConfig, pageLanguage)

    switch (embedType) {
        case "html":
        return styleMarketo ?
            <EmbeddedFormWrapper id={embedId}> <EmbedHtmlMarketo embedHtml={`${embedHtml}${clearNativeMarketoStylesheet}`}/>
                </EmbeddedFormWrapper>
                :
            <EmbedHtml id={embedId} embedHtml={embedHtml} {...props} />;
        case "url":
            return (
                <KoerberEmbed id={embedId}>
                    <div className="embed__video">
                        <iframe
                            className="video__player"
                            src={embedUrl}
                            loading="lazy"
                        />
                    </div>
                </KoerberEmbed>
            );

        case "youtube":
            return (
                <KoerberEmbed id={embedId}>
                    <div className="embed__video">
                        <iframe
                            className="video__player"
                            src={`https://www.youtube-nocookie.com/embed/${youtubeVideoId}?${youtubeMute}&${youtubeAutoPlay}&${youtubeLoop}&playlist=${youtubeVideoId}&${youtubePlaysInline}&${youtubeRel}`}
                            loading="lazy"
                            title={youtubeAccessibilityLabel}
                            frameBorder="0"
                            allow="accelerometer;autoplay;clipboard-write;encrypted-media;gyroscope;picture-in-picture;web-share"
                            allowFullScreen
                        />
                    </div>
                </KoerberEmbed>
            );

        default:
            return <></>;
    }
}

const EmbedHandleErrors = (props) => {
    return (
        <ErrorBoundary
            fallback={
                props.isInEditor || urlHasParam("wcmmode=disabled") ? (
                    <div
                        style={{
                            minHeight: "50px",
                            display: "flex",
                            alignItems: "center",
                            backgroundColor: "#ffe1db"
                        }}
                    >
                        <p>
                            The embed component is currently experiencing errors. Please try
                            again later.
                        </p>
                    </div>
                ) : (
                    <div></div>
                )
            }
        >
            <Embed {...props} />
        </ErrorBoundary>
    );
};

export default EmbedHandleErrors;
